import React from 'react'

import { WizClassifySelect,WizAuthority, WizClassifySelectRe, WizTableForm } from '@/containers/common';
export  function  _tableFormProps(entityType) {
    let config = { columns: [], tableApi: {} }
    let other = {
        selectType: 'radio'
    }
    switch (entityType) {
        case 0://imgOne
            config = WizTableForm.Config.program(this, { apiParams: { status: 1 } })
            break
        case 1://img
            config = WizTableForm.Config.exam(this, { apiParams: { status:1 } })
            break
        case 2:
            break
        case 26://img
            //直播
            config = WizTableForm.Config.live(this, {apiParams: {stateList: [2,3]}})
            break
        case 15://img
          config = WizTableForm.Config.apply(this, {apiParams: {status :1}})
          break
        case 5:
            break
        case 6:
            break
        default:
            other.disabled = true
    }
    let tableFormProps = {
        ...config,
        ...other
    }
    return tableFormProps
}
